import React, { ReactElement, ReactNode } from "react";
import { useStyles } from "./FormLayoutActions.styles";

interface FormLayoutActionsProps {
    children: ReactNode;
}

const FormLayoutActions = ({ children }: FormLayoutActionsProps): ReactElement => {
    const styles = useStyles();

    return <div className={styles.formActions}>{children}</div>;
};
export default FormLayoutActions;
